import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type PlanValidacion = components['schemas']['BateriaPlanValidacionRead']
type UploadTarget = components['schemas']['PlanValidacionUploadTargetRead']

const QUERY_KEY = ['bateria-plan-validacion']

/** G17′: `null` si nadie validó esta versión exacta del catálogo; la tarjeta P0 pinta sobre esto, no sobre un
 * cálculo propio. */
export function usePlanValidacion() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => (await api.get<PlanValidacion | null>('/admin/bateria/plan-validacion')).data,
  })
}

export async function mintPlanValidacionUpload(file: File): Promise<UploadTarget> {
  return (
    await api.post<UploadTarget>('/admin/bateria/plan-validacion-uploads', {
      filename: file.name,
      content_type: file.type,
      size_bytes: file.size,
    })
  ).data
}

/** El `catalogo_hash` lo calcula el servidor. */
export function useRegistrarPlanValidacion() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (input: {
      validado_por: string
      licencia: string
      validado_en: string
      soporte_object_key: string
      soporte_size_bytes: number
    }) => (await api.post<PlanValidacion>('/admin/bateria/plan-validacion', input)).data,
    onSuccess: (data) => queryClient.setQueryData(QUERY_KEY, data),
  })
}
